import React, {useState} from 'react';
import {Box, Flex, FormLabel} from '@chakra-ui/react';
import {get} from '../../service/ApiService';
import {Client, OpportunityPlan} from '../../service/Urls';
import Select from 'react-select';
import {useQuery} from 'react-query';

export default function ClientOSelect({onChange}) {
  const [value, setValue] = useState(null);

  const {data, isLoading} = useQuery(['client', 'clientList'], () => get(Client.LIST + '?PageSize=10000'));

  const clients =
    data?.data?.map(client => ({
      value: client?.id,
      label: `${client?.clId} | ${client?.clCname ?? ''}`,
    })) ?? [];

  const onSelect = async selectedClient => {
    const oppResponse = await get(OpportunityPlan.GET_BY_ID + '/' + selectedClient.value);

    if (!oppResponse.isSuccess) {
      setValue(null);
      onChange(null);

      return;
    }

    setValue(selectedClient);
    onChange(oppResponse);
  };

  return (
    <Flex mx={1}>
      <Box w="100%">
        <FormLabel fontSize="sm" mb="-0.5" ml="1">
          Select Client
        </FormLabel>
        <Select value={value} onChange={onSelect} options={clients} />
      </Box>
    </Flex>
  );
}
